import './Banner.css';

import React from 'react';
import PropTypes from 'prop-types';
import { generateClassName } from './helpers';

const Banner = ({ message, underline = true, className = null, headingLevel = 'h1', sectionTittle = null, showEllipsis = false }) => {
    const HeadingTag = headingLevel;
    const additionalClass = underline ? 'banner_underline' : '';
    return (
        <div className={`${generateClassName("banner", "-container", className, additionalClass)} ${showEllipsis ? 'ellipsis' : ''}`}>
            {sectionTittle && <HeadingTag className="banner-section-title">{sectionTittle}</HeadingTag>}
            <HeadingTag>{message}</HeadingTag>
        </div>
    );
};

Banner.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};

export default Banner;